var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95 12.9C10.2361 12.9 12.9 10.2361 12.9 6.95C12.9 3.66391 10.2361 1 6.95 1C3.66391 1 1 3.66391 1 6.95C1 10.2361 3.66391 12.9 6.95 12.9Z",
    stroke: "#6E6E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.95H12.9M9.23846 6.95C9.12605 9.12586 8.32461 11.2096 6.95 12.9C5.57539 11.2096 4.77395 9.12586 4.66154 6.95C4.77395 4.77414 5.57539 2.6904 6.95 1C8.32461 2.6904 9.12605 4.77414 9.23846 6.95Z",
    stroke: "#6E6E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.8430f23990247db6c993b110c15cb502.svg";
export { ForwardRef as ReactComponent };